<template>
  <div>
    <ts-button ref="uploadButton">Upload your file</ts-button>
    <div class="files">
      <div v-for="(file, i) in files" :key="i" class="file">
        <div class="info">
          <p class="filename">{{ file.name }}</p>
          <ts-button size="mini" circle @click="handleFileRemoveClick(file)">
            <ts-icon icon="xmark" size="xx-small" color="#000000" />
          </ts-button>
        </div>
        <div v-if="file.status === 'uploading'" class="progress">
          <ts-progress :percentage="file.percentage"></ts-progress>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.files {
  margin-top: 12px;
}

.file {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.32);
  border-radius: 20px;
  font-size: 12px;
  padding: 6px 12px;
  margin: 6px 0;
  box-shadow: -5px -5px 10px 0 rgba(250, 251, 255, 0.8), 5px 5px 10px 0 rgba(166, 171, 189, 0.48);

  .info {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .filename {
    flex-grow: 1;

    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
  }

  .progress {
    margin-top: 4px;
  }
}
</style>

<script>
import { omit } from 'lodash';

import uploader from '@/mixins/uploader';

export default {
  mixins: [uploader],
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      uploadingFiles: []
    };
  },
  computed: {
    files() {
      return [...this.value, ...this.uploadingFiles];
    }
  },
  methods: {
    handleFileRemoveClick(file) {
      if (file.resumableFile) {
        this.resumable.removeFile(file.resumableFile);
        this.uploadingFiles = this.uploadingFiles.filter(
          f => f.resumableFile.uniqueIdentifier !== file.resumableFile.uniqueIdentifier
        );
      } else {
        this.$emit(
          'input',
          this.value.filter(f => f.id !== file.id)
        );
      }
    }
  },
  mounted() {
    this.resumable.assignBrowse(this.$refs.uploadButton.$el);
    this.resumable.on('fileAdded', file => {
      this.uploadingFiles = [
        ...this.uploadingFiles,
        {
          id: file.uniqueIdentifier,
          name: file.fileName,
          resumableFile: file
        }
      ];
      this.resumable.upload();
    });
    this.resumable.on('fileSuccess', async file => {
      const uploadingFile = this.uploadingFiles.find(f => f.resumableFile.uniqueIdentifier == file.uniqueIdentifier);
      if (uploadingFile) {
        this.uploadingFiles = this.uploadingFiles.filter(
          f => f.resumableFile.uniqueIdentifier !== file.uniqueIdentifier
        );
        this.$emit('input', [...this.value, omit(uploadingFile, ['resumableFile'])]);
      }
    });
    this.resumable.on('fileError', async (file, message) => {
      const uploadingFile = this.uploadingFiles.find(f => f.resumableFile.uniqueIdentifier == file.uniqueIdentifier);
      if (uploadingFile) {
        uploadingFile.uploadError = true;
        uploadingFile.uploadErrorMessage = message;
      }
    });
  }
};
</script>
